import { useNavigate, useParams } from 'react-router-dom';
import { useMemo } from 'react';
import {
  CreateTermineDrawer,
  CreateTermineSheet,
  CreateTermineSheetWrapper,
  CreateTermineDrawerWrapper,
} from '@/domain/termine/features';
import { CreateTermineFormProvider } from '@/domain/termine/features/CreateTermin/shared/CreateTermineForm';

const mobile_breakpoint = 640;

function getViewType(): 'desktop' | 'mobile' {
  if (typeof window === 'undefined') {
    return 'mobile';
  }
  return window.innerWidth >= mobile_breakpoint ? 'desktop' : 'mobile';
}

export function CreateTermineWrapper() {
  const navigate = useNavigate();
  const { year, month } = useParams<{ year: string; month: string }>();

  const viewType = useMemo(() => getViewType(), []);

  function handleClose() {
    navigate(`/termine/uebersicht/${year}/${month}`);
  }

  const isDesktop = viewType === 'desktop';

  return isDesktop ? (
    <CreateTermineSheetWrapper onClose={handleClose}>
      <CreateTermineFormProvider>
        <CreateTermineSheet />
      </CreateTermineFormProvider>
    </CreateTermineSheetWrapper>
  ) : (
    <CreateTermineDrawerWrapper onClose={handleClose}>
      <CreateTermineFormProvider>
        <CreateTermineDrawer />
      </CreateTermineFormProvider>
    </CreateTermineDrawerWrapper>
  );
}
